/**
 * 产品
 */

export default [
    {
        path: '/aiJobPlatformPro',
        name: 'aiJobPlatformPro',
        component: () => import('../../views/product/aiJobPlatformPro.vue'),
        meta: {
            title: 'AI就业平台'
        }
    },
    {
        path: '/ylStarPro',
        name: 'ylStarPro',
        component: () => import('../../views/product/ylStarPro.vue'),
        meta: {
            title: '宇乐星球'
        }
    },
    {
        path: '/aiInterviewPro',
        name: 'aiInterviewPro',
        component: () => import('../../views/product/aiInterviewPro.vue'),
        meta: {
            title: 'AI面试亭'
        }
    },
    {
        path: '/aiInterviewAllPro',
        name: 'aiInterviewAllPro',
        component: () => import('../../views/product/aiInterviewAllPro.vue'),
        meta: {
            title: 'AI面试一体机'
        }
    },
    {
        path: '/aiCareerPro',
        name: 'aiCareerPro',
        component: () => import('../../views/product/aiCareerPro.vue'),
        meta: {
            title: 'AI生涯互动台'
        }
    },
    {
        path: '/vrCareerExpPro',
        name: 'vrCareerExpPro',
        component: () => import('../../views/product/vrCareerExpPro.vue'),
        meta: {
            title: 'VR职业体验一体机'
        }
    },
    {
        path: '/careerDevelopUtilsPro',
        name: 'careerDevelopUtilsPro',
        component: () => import('../../views/product/careerDevelopUtilsPro.vue'),
        meta: {
            title: '生涯发展工具系列'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/product/product.js